module.exports = __webpack_public_path__ + "img/20200620_094405.2a4c33b2.jpg";